import { styled } from '@lichtblick/styled';

export const Container = styled.div`
  padding: 2rem;
`;
